import axios from 'axios'
import { cookieGet, cookieRemove, cookieSet } from '@/common/cookie'
import { Message } from 'element-ui'
import { isPlainObject } from 'lodash'
import qs from 'qs'
import store from '@/store'
import router from '@/router'

// 记录和显示错误
function errorLog(info) {
  // 显示提示
  Message({
    message: info,
    type: 'error',
    duration: 5 * 1000
  })
}

// 成功
function success() {
  // 显示提示
  Message({
    message: cookieGet('language') == 'zh-CN' ? '成功' : 'success',
    type: 'success',
    duration: 3 * 1000
  })
}

function createAxios(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: 1000 * 180,
    withCredentials: true
  })

  /**
   * 请求拦截
   */
  instance.interceptors.request.use(config => {
    config.headers['language'] = cookieGet('language') == 'zh-CN' ? 'chs' : 'eng'
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    // config.headers['token'] = cookieGet('token') || ''
    config.headers['token'] = cookieGet('token') || '';
    // 默认参数
    var defaults = {}
    // 防止缓存，GET请求默认带_t参数
    if (config.method === 'get' || config.method === 'delete' || (config.data && config.data.noQs)) {
      config.params = {
        ...config.params,
        ...{ '_t': new Date().getTime() }
      }
    }
    // if (isPlainObject(config.params)) {
    //   config.params = {
    //     ...defaults,
    //     ...config.params
    //   }
    // }
    if (isPlainObject(config.data)) {
      // config.data = {
      //   ...defaults,
      //   ...config.data
      // }

      if (/^application\/x-www-form-urlencoded/.test(config.headers['Content-Type'])) {
        console.log('yes');
        if (!config.data.noQs) {
          config.data = qs.stringify(config.data)
        }
      }
    }
    return config
  }, error => {
    return Promise.reject(error)
  })

  /**
   * 响应拦截
   */
  instance.interceptors.response.use(response => {
    if (response.data instanceof Blob) {
      return response
    }
    else if (response.data.code === "401" || response.data.code === "10001") {
      store.dispatch('d2admin/account/logout')
      return Promise.reject(response.data.message)
    }
    //用户登录过期处理
    else if (response.data.code !== "0" && response.data.message === "USER0999") {
      //防止多次弹窗,这里给予cookie进行一次判定
      if (cookieGet('token') !== '') {
        errorLog('登录过期');
        cookieSet('token', '')
        router.replace('/login');
      }
      return Promise.reject(response.data.message);
    }
    else if (response.data.code !== "0" && response.data.message !== "SUCCESS") {
      errorLog(response.data.message)
      return Promise.reject(response.data.message)
    } else {
      //不要成功消息
      // if (response.config.method !== "get") {
      //   success()
      // }
      return response.data;
    }
  }, error => {
    errorLog(error.message)
    return Promise.reject(error)
  })

  return instance;
}

// axios主实例
const service = createAxios(process.env.VUE_APP_API);

export default service.request;